import { AnimatePresence } from "framer-motion"
import * as React from "react"
import Modal from "../molecules/Modals/Modal"
import LoginModalContainer from "../organisms/LoginScreens/LoginModalContainer"
import { useNavigate } from "react-router-dom"

const LoginPage: React.FunctionComponent = () => {
  React.useEffect(() => {
    document.title = "Log in"
  }, [])

  const navigate = useNavigate()
  const onGoToHomePage = () => navigate("/")

  return (
    <div>
      <AnimatePresence initial={false} mode="wait" onExitComplete={() => null}>
        <Modal open={true} onClose={onGoToHomePage} backdropColor="#D5E2EAe1">
          <LoginModalContainer onCloseModal={onGoToHomePage} />
        </Modal>
      </AnimatePresence>
    </div>
  )
}

export default LoginPage
